import React from 'react'
import { Pagination } from 'react-bootstrap'

class TablePagination extends React.Component {
  // Edge case: only 1 page
  // if click on ellipsis-left: back <5 page
  // if click on ellipsis-right: forward >5 page
  // if click on arrow: rotate pages

  // props: currentPageNum, setCurrentPageNum, maxPageNum

  constructor(props) {
    super(props)
    this.state = {
      median: 4,
      medianMax: props.maxPageNum - 3
    }

    this.medianMin = 4
  }

  componentWillReceiveProps(props) {
    // edge case scenario: search function makes currentPageNum goes out of bounds:
    if (this.props.currentPageNum > props.maxPageNum) {
      this.props.setCurrentPageNum(props.maxPageNum)
    }
    this.setState({
      medianMax: props.maxPageNum - 3
    })
  }

  setActivePage = async (i) => {
    if (await this.props.shouldDisableCollapseAnim(true, false)) {
      var oldPageNum = this.props.currentPageNum
      this.props.setCurrentPageNum(i)
      // if (i != 1 && oldPageNum == 1) {
      if (oldPageNum !== i) {
        this.props.flushNewDataCount()
      }
    }
    this.props.shouldDisableCollapseAnim(false, false)
  }

  onClickRightEllipsis = () => {
    var newVal = -1
    if (this.state.median + 3 > this.state.medianMax) {
      newVal = this.state.medianMax
    } else {
      newVal = this.state.median + 3
    }
    this.setState({
      median: newVal
    })
  }

  onClickLeftEllipsis = () => {
    var newVal = -1
    if (this.state.median - 3 < this.medianMin) {
      newVal = this.medianMin
    } else {
      newVal = this.state.median - 3
    }
    this.setState({
      median: newVal
    })
  }

  generateMedianPaginationItems() {
    var arrOfItems = []
    for (let i = this.state.median - 1; i <= this.state.median + 1; i++) {
      arrOfItems.push(this.generatePaginationItem(i))
    }
    return arrOfItems
  }

  generatePaginationItem(i) {
    return (
      <Pagination.Item
        key={i}
        className={
          i === 1 && this.props.maxPageNum === 1
            ? 'paginationFirst paginationLast'
            : i === 1 && this.props.currentPageNum === 1
            ? 'paginationFirst'
            : i === this.props.maxPageNum &&
              this.props.currentPageNum === this.props.maxPageNum
            ? 'paginationLast'
            : ''
        }
        onClick={() => this.setActivePage(i)}
        active={this.props.currentPageNum === i}
      >
        {i}
      </Pagination.Item>
    )
  }

  generatePagination() {
    if (this.props.maxPageNum < 7) {
      const arrOfPagItems = []
      for (let i = 1; i <= this.props.maxPageNum; i++) {
        arrOfPagItems.push(this.generatePaginationItem(i))
      }
      return arrOfPagItems
    } else {
      return (
        <div>
          {this.generatePaginationItem(1)}
          {this.state.median > this.medianMin ? (
            <Pagination.Ellipsis onClick={this.onClickLeftEllipsis} />
          ) : (
            this.generatePaginationItem(2)
          )}

          {this.generateMedianPaginationItems()}

          {this.state.median < this.state.medianMax ? (
            <Pagination.Ellipsis onClick={this.onClickRightEllipsis} />
          ) : (
            this.generatePaginationItem(this.props.maxPageNum - 1)
          )}
          {this.generatePaginationItem(this.props.maxPageNum)}
        </div>
      )
    }
  }

  onClickArrow = (increment) => {
    var newVal = this.props.currentPageNum + increment
    this.setActivePage(newVal)
    if (newVal <= this.state.medianMax && newVal >= this.medianMin) {
      this.setState({
        median: newVal
      })
    }
  }

  render() {
    return (
      <div className='tablePagination'>
        <Pagination>
          <Pagination.Prev
            key='00'
            className='paginationFirst'
            onClick={() => this.onClickArrow(-1)}
            disabled={this.props.currentPageNum === 1}
          />
          {this.generatePagination()}
          <Pagination.Next
            key='01'
            className='paginationLast'
            onClick={() => this.onClickArrow(1)}
            disabled={this.props.currentPageNum === this.props.maxPageNum}
          />
        </Pagination>
      </div>
    )
  }
}

export default TablePagination
